export default "__VITE_ASSET__95a69803__"